import { render, staticRenderFns } from "./center2.vue?vue&type=template&id=355aee75&scoped=true&"
import script from "./center2.vue?vue&type=script&lang=js&"
export * from "./center2.vue?vue&type=script&lang=js&"
import style0 from "./center2.vue?vue&type=style&index=0&id=355aee75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355aee75",
  null
  
)

export default component.exports